import BaseEntity from 'client/components/core/BaseEntity/BaseEntityNew'
import React from 'react'
import { BaseEditorField } from 'src/editor/shared/entities/base-editor-field'
import { FieldEntityInterface } from 'src/shared/entities/field/field-entity.schema'
import { EntityIdType } from 'src/shared/schemas/entity-id.schema'

interface FieldNewProps {
  entity: FieldEntityInterface
  isMoveDownAllowed: boolean
  isMoveUpAllowed: boolean
  isSaveAllowed?: boolean
  isRemoveAllowed?: boolean
  isCopyAllowed?: boolean
  dropBoxAllowedEntityIds?: EntityIdType[]
}

export const FieldNew = ({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
  isRemoveAllowed = true,
  isSaveAllowed = true,
  isCopyAllowed = true,
  dropBoxAllowedEntityIds,
}: FieldNewProps) => {
  return (
    <BaseEntity
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
      isRemoveAllowed={isRemoveAllowed}
      isSaveAllowed={isSaveAllowed}
      isCopyAllowed={isCopyAllowed}
      dropBoxAllowedEntityIds={dropBoxAllowedEntityIds}
    >
      <BaseEditorField entity={entity} />
    </BaseEntity>
  )
}
